export const GET_PURCHASE_ORDER_LIST_ASYNC = 'GET_PURCHASE_ORDER_LIST_ASYNC';
export const GET_PURCHASE_ORDER_LIST_SUCCESS = 'GET_PURCHASE_ORDER_LIST_SUCCESS';
export const GET_PURCHASE_ORDER_LIST_FAIL = 'GET_PURCHASE_ORDER_LIST_FAIL';

export const GET_PURCHASE_ORDER_DETAIL_ASYNC = 'GET_PURCHASE_ORDER_DETAIL_ASYNC';
export const GET_PURCHASE_ORDER_DETAIL_SUCCESS = 'GET_PURCHASE_ORDER_DETAIL_SUCCESS';
export const GET_PURCHASE_ORDER_DETAIL_FAIL = 'GET_PURCHASE_ORDER_DETAIL_FAIL';

export const GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC = 'GET_SUBCONTRACTOR_PURCHASE_ORDER_LIST_ASYNC';

export const GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC = 'GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_ASYNC';
export const GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_SUCCESS = 'GET_SUBCONTRACTOR_PURCHASE_ORDER_DETAIL_SUCCESS';

export const CREATE_PURCHASE_ORDER_ASYNC = 'CREATE_PURCHASE_ORDER_ASYNC';
export const CREATE_PURCHASE_ORDER_SUCCESS = 'CREATE_PURCHASE_ORDER_ASYNC_SUCCESS';
export const CREATE_PURCHASE_ORDER_FAIL = 'CREATE_PURCHASE_ORDER_ASYNC_FAIL';

export const EDIT_PURCHASE_ORDER_ASYNC = 'EDIT_PURCHASE_ORDER_ASYNC';
export const EDIT_PURCHASE_ORDER_SUCCESS = 'EDIT_PURCHASE_ORDER_SUCCESS';
export const EDIT_PURCHASE_ORDER_FAIL = 'EDIT_PURCHASE_ORDER_FAIL';

export const PURCHASE_ORDER_ATTACHMENTS_ASYNC = 'PURCHASE_ORDER_ATTACHMENTS_ASYNC';
export const PURCHASE_ORDER_ATTACHMENTS_SUCCESS = 'PURCHASE_ORDER_ATTACHMENTS_SUCCESS';
export const PURCHASE_ORDER_ATTACHMENTS_FAIL = 'PURCHASE_ORDER_ATTACHMENTS_FAIL';

export const RESEND_PO_ASYNC = 'RESEND_PO_ASYNC';

export const PRINT_PREVIEW_PURCHASE_ORDER_ASYNC = 'PRINT_PREVIEW_PURCHASE_ORDER_ASYNC';
export const PRINT_PREVIEW_SUBCONTRACTOR_PURCHASE_ORDER_ASYNC = 'PRINT_PREVIEW_SUBCONTRACTOR_PURCHASE_ORDER_ASYNC';




// WEBPACK FOOTER //
// ./src/Purchase-Orders/constants.js